import MoneyFormatter from "../../awrabet/utils/money-formatter";
export * from "../../awrabet/utils/money-formatter";
export default MoneyFormatter;